import styled from '@emotion/styled'
import { colors, zIndex } from '../../../styles'
import { CSSObject } from '@emotion/react'
import {
  Box,
  Color,
  Display,
  FlexDirection,
  FontFamily,
  Icon,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import React from 'react'

// Desktop

export const OuterWrapper = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
})

export const OptionsButton = styled.div<{ buttonStyles?: CSSObject }>(({ buttonStyles = {} }) => ({
  zIndex: 11,
  color: colors.bluecheese,
  fontWeight: '700',
  ['&:hover']: {
    color: colors.s600,
    cursor: 'pointer',
  },
  ...buttonStyles,
}))

export const DropDown = styled.div<{ showOptions: boolean }>(({ showOptions }) => ({
  position: 'absolute',
  background: colors.white,
  zIndex: zIndex.top,
  display: 'none',
  top: '2.8rem',
  boxShadow: '0 18px 14px 0 rgba(51, 61, 71, 0.2)',
  padding: '1rem',
  // list elements has 0.5rem margin-bottom
  // that's why we need 0.5rem padding for bottom
  paddingBottom: '0.5rem',
  minWidth: '100%',
  width: 'calc(100% + 2rem)',
  margin: '0 -1rem',
  ...(showOptions
    ? {
        display: 'block',
      }
    : null),
}))

// Mobile

export const Drawer = withCitrusTheme(Box, () => ({
  backgroundColor: Color.White,
  position: 'fixed',
  top: 'auto',
  bottom: '65px',
  width: '100vw',
  minHeight: 'auto',
  zIndex: '100',
  left: '0',
  [`@media (max-width: '420px')`]: {
    transform: 'translate(-50%, 0)',
  },
}))

export const DrawerBody: React.FC = withCitrusTheme(Box, () => ({
  textAlign: 'left',
  margin: '0',
  padding: '1rem',
  overflowY: 'scroll',
}))

export const IconCustom = withCitrusTheme(Icon, () => ({
  fontFamily: FontFamily.Bold,
}))

export const DrawerHeader: React.FC = withCitrusTheme(Box, () => ({
  display: Display.Flex,
  flexDirection: FlexDirection.Row,
  justifyContent: JustifyContent.SpaceBetween,
  padding: '1rem 1rem 0rem',
}))

export const overlay = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 100,
}

export const content: React.CSSProperties = {
  backgroundColor: 'transparent',
  border: 0,
  position: 'relative',
}
